export enum LineItemModalEnums {
  LINE_ITEMS_CATALOG = 'line-items-catalog',
}
